import { render, staticRenderFns } from "./RealtimeUsersDetailsTable.vue?vue&type=template&id=4d2fcaf4&scoped=true"
import script from "./RealtimeUsersDetailsTable.vue?vue&type=script&lang=js"
export * from "./RealtimeUsersDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./RealtimeUsersDetailsTable.vue?vue&type=style&index=0&id=4d2fcaf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2fcaf4",
  null
  
)

export default component.exports